import 'blueimp-canvas-to-blob';
import loadImage from 'blueimp-load-image';

export const ImageOrientations = {
    NONE: 1,
    LANDSCAPE: 2,
    PORTRAIT: 3,
};

export const processImage = async ({
    file,
    maxWidth = 2048,
    maxHeight = 2048,
    format = 'image/jpeg',
    useBase64 = false,
    quality = 0.6, // Don't rely on it. It's only supported by a handful of mobile browsers
}) => {
    if (!file) {
        console.error('No image file specified for processImage');
        return null;
    }

    try {
        const canvas = await new Promise(resolve =>
            loadImage(file, resolve, {canvas: true, orientation: true, maxWidth, maxHeight}),
        );

        return new Promise(resolve => {
            try {
                if (useBase64) {
                    const encoded = canvas.toDataURL(file.type.replace('jpg', 'jpeg')); // jpg is not a valid encoding
                    const split = encoded.split('base64,');
                    resolve(split[1]); // The endpoint just wants the raw base64 string without encoding metadata
                } else {
                    canvas.toBlob(
                        blob => resolve(blob),
                        format,
                        quality,
                    );
                }
            } catch (e) {
                console.error('processImage canvas error: ', e);
                return null; // Use a fallback image
            }

            return null;
        });
    } catch (e) {
        console.error('processImage error: ', e);

        return null; // Use a fallback image if device does not support any of above canvas operations
    }
};



// WEBPACK FOOTER //
// ./src/helpers/Image.js